import Vue from 'vue'

// EventBus is een manier om applicatiebreed te communiceren door middel van event triggers. Dus alle componenten staan in contact met de EventBus als deze wordt geimporteerd.

export const EventBus = new Vue()